var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.roles.length)?_c('div',{class:_vm.$style.root},[_c('div',{class:_vm.$style.label},[_vm._v("Войти как:")]),_c('VBtnToggle',{attrs:{"value":_vm.role,"dense":""},on:{"change":_vm.onUpdate}},_vm._l((_vm.roles),function({text, value}){return _c('VBtn',{key:value,attrs:{"value":value}},[_vm._v(" "+_vm._s(text)+" ")])}),1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }